import LogoutIcon from "@mui/icons-material/Logout";
import { CircularProgress, Tooltip } from "@mui/material";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { getEmpleadores } from "../../redux/actions/auth";
import { StyledEmpleador } from "../styled/Empleador";
import { seleccionUsuarioValidation } from "./validation/formValidations";
const SeleccionUsuarioForm = ({ handleSubmit, initialValues, loading, empleadores, logout }) => {
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={seleccionUsuarioValidation}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, }) => (
        <StyledEmpleador.Form>
          <div>
            <StyledEmpleador.InputLabel
              getOptions={() => dispatch(getEmpleadores())}
              options={empleadores}
              variant="outlined"
              margin="normal"
              fullWidth
              label="Empleadores"
              name="empleador"
              autoFocus
              type="text"
              callBack={(value) => {
                if (value) {
                  setFieldValue("nombreEmpleador", value.nombre);
                }
              }}
            />
          </div>
          <StyledEmpleador.ButtonsContainer>
            <Tooltip title="Cerrar Sesión">
              <StyledEmpleador.LogoutButton color="info" onClick={logout}>
                <LogoutIcon
                />
              </StyledEmpleador.LogoutButton>
            </Tooltip>


            <StyledEmpleador.LoginButton
              color="primary"
              variant="contained"
              fullWidth
              type="submit"

            >
              {loading ? (
                <CircularProgress size={24} thickness={4} color="primary" />
              ) : (
                "Ingresar"
              )}
            </StyledEmpleador.LoginButton>
          </StyledEmpleador.ButtonsContainer>
        </StyledEmpleador.Form>
      )}
    </Formik>
  )
}

export default SeleccionUsuarioForm;